import React from "react";
import { ProfilHeader } from "../../pages/Profil";
import Button from "@mui/material/Button";
import { Help } from "../../utils";

import Stack from "@mui/material/Stack";
import "../style/constante_style.css";
import { Ellipsis } from "antd-mobile";

const Body = ({ dataInfo, titleInfo, widthBody }) => {
  return (
    <div className="conteneur-info-detail">
      <h5
        className="my-3 style-title_info position-relative text-center"
        style={{ width: widthBody }}>
        {titleInfo}
      </h5>
      {dataInfo.map((item, index) => (
        <div key={index}>
          {item.value !== 0 && item.value !== undefined && (
            <>
              <h6 className="fw-bold my-2">{item.title}</h6>
              {typeof item.value === "string" && (
                <Ellipsis
                  direction="end"
                  content={item.value}
                  rows={3}
                  style={{ width: "420px", color: "gray" }}
                  expandText="Voir plus"
                  collapseText="Voir moins"
                />
              )}
              {typeof item.value === "number" && (
                <span className="text-secondary">
                  {Help.convertInMoney(item.value)}
                </span>
              )}
            </>
          )}
        </div>
      ))}
      {!dataInfo.length && <h3 className="my-3 text-center">Pas de biens</h3>}
    </div>
  );
};
const BtnInfoDetail = ({ dataBtnWithOptions, arrayForInfoOnContrat }) => {
  return (
    <Stack direction="row" spacing={2} sx={{ justifyContent: "space-around" }}>
      {dataBtnWithOptions.map(
        (item, index) =>
          item.isVisible && (
            <Button
              value={arrayForInfoOnContrat}
              key={index}
              variant="contained"
              startIcon={item.icone}
              sx={{
                backgroundColor: !item.isColor
                  ? "var(--primary-color)"
                  : item.backgroundColor,
                color: "black",
              }}
              onClick={item.methode}>
              {item.titleBtn}
            </Button>
          )
      )}
    </Stack>
  );
};
function InfoDetails({
  namePerson,
  detailPhone,
  detailAdresse,
  dataInfo,
  titleInfo,
  dataBtnWithOptions,
  detailEmail,
  widthBody,
  arrayForInfoOnContrat,
}) {
  return (
    <div className="d-flex justify-content-center my-4 ">
      <div
        className="conteneur-info-detail p-5 rounded-3 shadow"
        style={{ background: "#F7F7F7" }}>
        {namePerson && (
          <ProfilHeader
            namePerson={namePerson}
            detailPhone={detailPhone}
            detailAdresse={detailAdresse}
            detailEmail={detailEmail}
            detailUserInfo={true}
          />
        )}

        <br />
        {dataInfo.length > 0 && (
          <Body
            dataInfo={dataInfo}
            titleInfo={titleInfo}
            widthBody={widthBody}
          />
        )}

        <br />
        {dataBtnWithOptions && dataBtnWithOptions.length > 0 && (
          <BtnInfoDetail
            arrayForInfoOnContrat={arrayForInfoOnContrat}
            dataBtnWithOptions={dataBtnWithOptions}
          />
        )}
      </div>
    </div>
  );
}

export default InfoDetails;
